import { api, handleResponse, handleError } from "./apiServices";
const baseURL = `api/venueStaff/`;
export const getStaff = (token, data) =>
  api(token)
    .post(`${baseURL}getAll`, data)
    .then(handleResponse)
    .catch(handleError);

export const getStaffAllData = token =>
  api(token)
    .get(`${baseURL}getAllStaffData`)
    .then(handleResponse)
    .catch(handleError);

export const addStaff = (token, data) =>
  api(token)
    .post(`${baseURL}create`, data)
    .then(handleResponse)
    .catch(handleError);

export const editStaff = (token, id, data) =>
  api(token)
    .put(`${baseURL}edit/${id}`, data)
    .then(handleResponse)
    .catch(handleError);

export const deleteStaff = (token, id) =>
  api(token)
    .delete(`${baseURL}delete/${id}`)
    .then(handleResponse)
    .catch(handleError);

export const changeStaffStatus = (token, id, data) =>
  api(token)
    .put(`${baseURL}update-status/${id}`, data)
    .then(handleResponse)
    .catch(handleError);

export const getAllVenueStaffByServices = (token, data) =>
  api(token)
    .post(`${baseURL}getAllStaffDataByService`, data)
    .then(handleResponse)
    .catch(handleError);
